const initialState = {
  loading: false,
  error: null,
};

export const sidebarSectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_SIDEBAR_SECTION_REQUEST":
    case "UPDATE_SIDEBAR_SECTION_REQUEST":
    case "DELETE_SIDEBAR_SECTION_REQUEST":
    case "ADD_SIDEBAR_SUBSECTION_REQUEST":
    case "UPDATE_SIDEBAR_SUBSECTION_REQUEST":
    case "DELETE_SIDEBAR_SUBSECTION_REQUEST":
      return { ...state, loading: true, error: null };

    case "ADD_SIDEBAR_SECTION_SUCCESS":
    case "UPDATE_SIDEBAR_SECTION_SUCCESS":
    case "DELETE_SIDEBAR_SECTION_SUCCESS":
    case "ADD_SIDEBAR_SUBSECTION_SUCCESS":
    case "UPDATE_SIDEBAR_SUBSECTION_SUCCESS":
    case "DELETE_SIDEBAR_SUBSECTION_SUCCESS":
      return { ...state, loading: false, error: null };

    case "ADD_SIDEBAR_SECTION_FAIL":
    case "UPDATE_SIDEBAR_SECTION_FAIL":
    case "DELETE_SIDEBAR_SECTION_FAIL":
    case "ADD_SIDEBAR_SUBSECTION_FAIL":
    case "UPDATE_SIDEBAR_SUBSECTION_FAIL":
    case "DELETE_SIDEBAR_SUBSECTION_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};